// extracted by mini-css-extract-plugin
module.exports = {"table":"ProductDownloads_table__NBhOh"};